import { FC, ReactNode } from 'react';
import mapboxgl from 'mapbox-gl';
import { QESAlert } from '@app/shared/qes-standards/Alert';

interface MapboxSupportAlertProps {
  children?: ReactNode;
}

export const MapboxSupportAlert: FC<MapboxSupportAlertProps> = ({ children }) => {
  // Not supported at all
  if (!mapboxgl.supported()) {
    return (
      <div>
        <QESAlert type="warning" persist={true}>
          <strong>
            Your browser does not support our mapping application. QES Maps support the latest version of Chrome, Edge, Firefox, and Safari.
          </strong>
        </QESAlert>
      </div>
    );
  }

  // Supported, but only in software rendering mode
  if (!mapboxgl.supported({ failIfMajorPerformanceCaveat: true })) {
    return (
      <div>
        <QESAlert type="warning">
          <strong>
            Your computer has limited acceleration for graphics display due to your Graphics Processing Unit.
            This may result in missing map functionality and may cause maps to run slowly and have lower resolution
            compared to other machines.
          </strong>
        </QESAlert>
        {children}
      </div>
    );
  }

  // Fully supported which is hardware-accelerated
  return <>{children}</>;
};
